import { Injectable, isDevMode } from '@angular/core';

const KEY = 'authRegionalToken';

@Injectable({ providedIn: 'root' })
export class TokenRegionalService {
  storage = isDevMode() ? window.localStorage : window.sessionStorage;

  hasToken() {
    return !!this.getToken();
  }

  setToken(token: string) {
    this.storage.setItem(KEY, token);
  }

  getToken() {
    return this.storage.getItem(KEY);
  }

  removeToken() {
    this.storage.removeItem(KEY);
  }
}
